import {
  ADD_NEW_JOB,
  RESET_JOBS,
  SET_ACTIVE_JOB,
  ADD_MESSAGE_TO_JOB,
  ADD_MESSAGE_TO_JOB_BY_IDENTIFIER,
  ADD_MESSAGE_TO_JOB_BY_PROTOCOL,
  REMOVE_JOB_FROM_LIST,
  ADD_TAG_TAGS_ATTENDANCE,
  REMOVE_TAG_TAGS_ATTENDANCE,
  SET_MESSAGES_ON_JOB_HISTORY_FROM_ACTIVE_JOB,
  NEW_MESSAGE_NOT_READ,
  ALTER_FIELD_SCRIPT,
  UPDATE_ACTIVE_JOB,
  UPDATE_STATUS_MESSAGE,
  SET_NOTIFICATIONS_ACTIVEJOB,
  SET_HISTORY_ACTIVE_JOB,
  SET_MESSAGES_FROM_HISTORY,
  CLEAR_CONTACT_HISTORY,
  DISABLE_JOB,
  NEW_COLUMN_CONTACT_COLUMNS_JOB,
  UPDATE_JOB_CONTACT,
  UPDATE_JOB_CONTACT_COLUMNS,
  SET_TAGS_JOB,
  FORCE_UPDATE_JOB,
  SET_MESSAGES_JOB,
  UPDATE_JOB,
  SET_CLIENT_TYPING,
  SET_CLIENT_STATUS,
  CLEAR_PROTOCOL,
  SET_JOB_TIMES_INFORMATIONS_COMMUNICATOR,
  NEW_MANUAL_ACTIVATION,
  DELETE_MANUAL_ACTIVATION,
  ADD_MESSAGES_HISTORY_JOB,
  INCREMENT_PAGE_HISTORY_MESSAGE,
  ADD_INBOX_JOB,
  REMOVE_INBOX_JOB,
  UPDATE_MESSAGE_JOB_BY_CUSTOM_ID,
  ADD_LAST_CONTACT,
  UPDATE_MESSAGE_TO_SEND_BY_JOB,
  SAVE_UNATTENDED_MESSAGE,
  DELETE_UNATTENDED_MESSAGES,
  ADD_INBOX_IN_PROCCESS,
  REMOVE_INBOX_IN_PROCCESS,
  WHATSAPP_NUMBER_NOT_EXISTS,
  DISABLE_CONVERSATION_TAB,
  ENABLE_CONVERSATION_TAB,
  DISABLE_CONVERSATION_OPTIONS,
  ENABLE_CONVERSATION_OPTIONS,
  SET_ACK_CALL_REQUEST_DIALOG,
  ENABLE_JOB_TEMPLATE_CONVERSATION,
  DISABLE_JOB_TEMPLATE_CONVERSATION,
  SET_TRANSFER_ASSISTED,
  SET_TRANSFER_ASSISTED_ACCEPTED,
  SET_WHATSAPP_KEEP_ALIVE,
  SET_NEW_WHATSAPP_MESSAGE_NOTIFICATION,
  SET_WHATSAPP_TEMPLATE_SENT,
  SET_ACK_CALL_REQUEST_INFORMATION,
  RESET_ACK_CALL_REQUEST_DIALOG,
  CLEAN_CURRENT_JOBS,
  BACKUP_CURRENT_PROTOCOL_JOBS,
  CLEAN_BACKUP_PROTOCOLS,
  DISABLED_JOB_ITEMS,
  SET_JOB_CHANNEL,
  CLEAR_JOBS,
  RESET_AGENT_UNREAD_MESSAGES,
  SET_LAST_MESSAGE,
  SET_JOBS,
  ADD_ATTENDANCE_JOB,
  ADD_MESSAGE_ANSWERED,
  SET_JOBS_PAGINATED,
  SET_ATTENDANCE_TAGS_JOB,
  SET_CONTACT_TAGS_FOR_CONTACT,
  SET_EMPLOYER_TAGS_FOR_EMPLOYER,
  SET_ACK_CALL_REQUEST_IN_PROGRESS,
  SET_TRANSFER_ASSISTED_WAITING_CONFIRMATION,
} from '../../mutation-types';

import { hasPropertyObject } from '@/shared/utils/helpers';
import Vue from 'vue';

const jobActive = (disabled) => !disabled;

const isNotActiveJob = (activeProtocol, jobProtocol) =>
  activeProtocol !== jobProtocol;

const isJobMessage =
  (identifier, propertyIdentifier = 'contactIdentifier') =>
  (job) =>
    job && job[propertyIdentifier] === identifier;

const findIndexJobMessage = (identifier, propertyIdentifier, jobList) =>
  jobList.findIndex(isJobMessage(identifier, propertyIdentifier));

const getIndexJob = (jobList, protocol) =>
  jobList.findIndex((job) => job && job.protocol === protocol);

const mutations = {
  [ADD_NEW_JOB](state, job) {
    state.jobList?.unshift(job);
  },

  [ADD_TAG_TAGS_ATTENDANCE](state, newTag) {
    const indexActiveJob = getIndexJob(state.jobList, state.activeJob);

    state.jobList[indexActiveJob].tags.push(newTag);
  },

  [SET_TAGS_JOB](state, { protocol, tags = [] }) {
    const indexJob = getIndexJob(state.jobList, protocol);

    state.jobList[indexJob].tags = tags;
  },

  [SET_MESSAGES_JOB](state, { protocol, messages = [] }) {
    const indexJob = getIndexJob(state.jobList, protocol);

    state.jobList[indexJob].messages = messages;
  },

  [CLEAR_CONTACT_HISTORY](state, jobProtocol) {
    const indexActiveJob = getIndexJob(state.jobList, jobProtocol);
    const job = state.jobList[indexActiveJob];

    job.historyFromContact = {};
    job.paramsHistory = {};

    state.jobList.splice(indexActiveJob, 1, job);
  },

  [UPDATE_JOB](state, { property, value, protocol }) {
    const jobIndex = getIndexJob(state.jobList, protocol);
    const job = state.jobList[jobIndex];

    if (!job) {
      console.log(
        'Não há nenhum atendimento com o protocol informado :(',
        protocol,
      );
      return;
    }

    job[property] = value;
  },

  [FORCE_UPDATE_JOB](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];

    if (job !== undefined) {
      state.jobList.splice(indexJob, 1, job);
    }
  },

  [REMOVE_TAG_TAGS_ATTENDANCE](state, removeTag) {
    const getIndexTag = (tags, removeTagId) =>
      tags.findIndex((tag) => tag.id == removeTagId);
    const indexJob = getIndexJob(state.jobList, state.activeJob);

    const indexTag = getIndexTag(state.jobList[indexJob].tags, removeTag.id);

    state.jobList[indexJob].tags.splice(indexTag, 1);
  },

  [SET_ACTIVE_JOB](state, protocol) {
    state.activeJob = protocol;
    if (protocol) {
      state.jobList.forEach((value) => {
        if (value) {
          if (value.protocol == protocol) {
            value.notifications = 0;
          }
        }
      });
    } else {
      if (state.jobList.length > 0) {
        state.jobList[0].notifications = 0;
      }
    }
  },

  [ADD_MESSAGE_TO_JOB](state, { protocol, message }) {
    const indexActiveJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexActiveJob];

    if (job.protocol == protocol) {
      if (message.message_media_type == 'sticker') {
        state.jobList[indexActiveJob].lastMessage = 'Você: 🖼️ Figurinha';
      } else if (message.message_media_type === 'audio') {
        state.jobList[indexActiveJob].lastMessage = 'Você: 🎧 Áudio';
      } else if (message.message_media_type === 'image') {
        state.jobList[indexActiveJob].lastMessage = 'Você: 🖼️ Foto';
      } else if (message.message_media_type === 'video') {
        state.jobList[indexActiveJob].lastMessage = 'Você: 🎥 Vídeo';
      } else if (message.message_media_type === 'file') {
        state.jobList[indexActiveJob].lastMessage = 'Você: 📄 Documento';
      } else if (message.message_media_type === 'contact') {
        state.jobList[indexActiveJob].lastMessage = 'Você: 📱 Contato';
      } else {
        state.jobList[indexActiveJob].lastMessage = 'Você: ' + message.message;
      }

      state.jobList[indexActiveJob].messages.push(message);
    }
  },

  [ADD_MESSAGE_TO_JOB_BY_IDENTIFIER](
    state,
    { propertyIdentifier, identifier, message },
  ) {
    const activeProtocol = state.activeJob;
    const indexJob = findIndexJobMessage(
      identifier,
      propertyIdentifier,
      state.jobList,
    );
    const job = state.jobList[indexJob];

    if (job) {
      if (jobActive(job.disabled)) {
        job.messages.push(message);
      }
      if (isNotActiveJob(activeProtocol, job.protocol)) {
        job.messagesNotRead = job.messagesNotRead ? job.messagesNotRead + 1 : 1;
      }

      job.notifications = job.notifications ? job.notifications + 1 : 1;
    }

    state.jobList.splice(indexJob, 1, job);
  },

  [ADD_MESSAGE_TO_JOB_BY_PROTOCOL](
    state,
    { propertyIdentifier, protocol, message },
  ) {
    const activeProtocol = state.activeJob;
    // const indexJob = findIndexJobMessage(identifier, propertyIdentifier, state.jobList)
    const indexJob = getIndexJob(state.jobList, protocol);

    const job = state.jobList[indexJob];

    if (job) {
      if (jobActive(job.disabled)) {
        job.messages.push(message);
      }

      if (isNotActiveJob(activeProtocol, job.protocol)) {
        job.messagesNotRead = job.messagesNotRead ? job.messagesNotRead + 1 : 1;
      }

      job.notifications = job.notifications ? job.notifications + 1 : 1;
    }

    job.lastMessage = message.message;

    if (message.message_media_type === 'sticker') {
      job.lastMessage = '🖼️ Figurinha';
    } else if (message.message_media_type === 'audio') {
      job.lastMessage = '🎧 Áudio';
    } else if (message.message_media_type === 'image') {
      job.lastMessage = '🖼️ Foto';
    } else if (message.message_media_type === 'video') {
      job.lastMessage = '🎥 Vídeo';
    } else if (message.message_media_type === 'file') {
      job.lastMessage = '📄 Documento';
    } else if (message.message_media_type === 'contact') {
      job.lastMessage = '📱 Contato';
    } else {
      job.lastMessage = message.message;
    }

    state.jobList.splice(indexJob, 1, job);
  },

  [SET_JOBS](state, jobs) {
    state.jobList = jobs;
  },

  [SET_JOBS_PAGINATED](state, { jobs, push = false }) {
    if (push) {
      state.jobList = [...state.jobList, ...jobs];
    } else {
      state.jobList = jobs;
    }
  },

  [REMOVE_JOB_FROM_LIST](state, protocol) {
    state.jobList = state.jobList.filter(
      (job) => job && job.protocol != protocol,
    );
    if (state.messageToSend[protocol]) delete state.messageToSend[protocol];
  },

  [CLEAR_PROTOCOL](state) {
    state.activeJob = null;
  },

  [RESET_JOBS](state) {
    state.jobList = [];
    state.inboxJobs = [];
    state.activeJob = null;
    state.inbox.inboxInProccess = [];
  },

  [CLEAR_JOBS](state) {
    state.jobList = [];
    state.activeJob = null;
  },

  [UPDATE_ACTIVE_JOB](state, { newValue, property }) {
    if (!state.activeJob) return;
    const activeActiveJobProtocol = state.activeJob;
    const indexActiveJob = getIndexJob(state.jobList, activeActiveJobProtocol);

    const job = state.jobList[indexActiveJob];
    if (job) {
      job[property] = newValue;
      state.jobList.splice(indexActiveJob, 1, job);
    }
  },

  [SET_HISTORY_ACTIVE_JOB](state, history) {
    const hasValueHistory = Object.keys(history).length;

    if (hasValueHistory) {
      const activeActiveJobProtocol = state.activeJob;
      const indexActiveJob = getIndexJob(
        state.jobList,
        activeActiveJobProtocol,
      );
      const job = state.jobList[indexActiveJob];
      const historyInJob = 'historyFromContact' in job;

      if (!historyInJob) job.historyFromContact = {};

      Object.keys(history).forEach((date) => {
        if (job.historyFromContact[date]) {
          job.historyFromContact[date] = job.historyFromContact[date].concat(
            history[date],
          );
        } else {
          job.historyFromContact[date] = history[date];
        }
      });

      state.jobList.splice(indexActiveJob, 1, job);
    }
  },

  [SET_MESSAGES_ON_JOB_HISTORY_FROM_ACTIVE_JOB](state, { protocol, messages }) {
    const indexActiveJob = getIndexJob(state.jobList, state.activeJob);
    const activeJob = state.jobList[indexActiveJob];
    const history = activeJob.history;

    Object.keys(history).forEach((group) => {
      history[group].forEach((job, key) => {
        if (job.protocol_number == protocol) {
          activeJob.history[group][key].messages = messages;
        }
      });
    });

    state.jobList.splice(indexActiveJob, 1, activeJob);
  },

  [SET_MESSAGES_FROM_HISTORY](state, { protocol, groupProtocol, messages }) {
    if (messages.length) {
      const indexActiveJob = getIndexJob(state.jobList, state.activeJob);
      const activeJob = state.jobList[indexActiveJob];
      if (activeJob) {
        if (!activeJob.historyFromContact) {
          activeJob.historyFromContact = {};
        }
        const historyGroup = activeJob.historyFromContact[groupProtocol];
        const historyMessagesIndex = historyGroup.findIndex(
          (history) => history.protocol == protocol,
        );

        activeJob.historyFromContact[groupProtocol][
          historyMessagesIndex
        ].messages = messages;

        state.jobList.splice(indexActiveJob, 1, activeJob);
      }
    }
  },

  [NEW_MESSAGE_NOT_READ](state) {
    const activeActiveJobProtocol = state.activeJob;
    const indexActiveJob = getIndexJob(state.jobList, activeActiveJobProtocol);
    const job = state.jobList[indexActiveJob];

    job.messagesNotRead = job.messagesNotRead ? job.messagesNotRead + 1 : 1;

    state.jobList.splice(indexActiveJob, 1, job);
  },

  [ALTER_FIELD_SCRIPT](state, fieldUpdate) {
    const indexActiveJob = getIndexJob(state.jobList, state.activeJob);
    const job = state.jobList[indexActiveJob];

    const existPropertieFiedlsScript = hasPropertyObject(
      'fiedlsScriptAltered',
      job,
    );

    if (!existPropertieFiedlsScript) {
      job.fiedlsScriptAltered = [];
      return job.fiedlsScriptAltered.push(fieldUpdate);
    }

    const fieldIndex = job.fiedlsScriptAltered.findIndex(
      (field) => field.id == fieldUpdate.id,
    );

    if (fieldIndex !== -1) {
      if (fieldUpdate.value == '') {
        let removed = job.fiedlsScriptAltered.splice(fieldIndex, 1);
        return state.jobList.splice(indexActiveJob, 1, job);
      }
      return job.fiedlsScriptAltered.splice(fieldIndex, 1, fieldUpdate);
    }

    job.fiedlsScriptAltered.push(fieldUpdate);

    if (fieldUpdate.value == '') {
      let remov1 = job.fiedlsScriptAltered.splice(fieldIndex, 1);
    }

    state.jobList.splice(indexActiveJob, 1, job);
  },

  [SET_NOTIFICATIONS_ACTIVEJOB](state, notification) {
    const activeActiveJobProtocol = state.activeJob;
    const indexActiveJob = getIndexJob(state.jobList, activeActiveJobProtocol);
    const job = state.jobList[indexActiveJob];

    job.notifications = notification;

    state.jobList.splice(indexActiveJob, 1, job);
  },

  [DISABLE_JOB](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);

    const job = state.jobList[indexJob];
    if (job) {
      job.disabled = true;
      state.jobList.splice(indexJob, 1, job);
    }
  },

  [WHATSAPP_NUMBER_NOT_EXISTS](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);

    const job = state.jobList[indexJob];
    if (job) {
      job.whatsappNumberNotExists = true;
      state.jobList.splice(indexJob, 1, job);
    }
  },

  [NEW_COLUMN_CONTACT_COLUMNS_JOB](state, { column, protocol }) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];

    job.contactColumns = [column, ...job.contactColumns];
    state.jobList.splice(indexJob, 1, job);
  },

  [ADD_LAST_CONTACT](state, { lastContact, protocol }) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];
    job.contact.lastContact = lastContact;
  },

  [UPDATE_JOB_CONTACT](state, { newValue, property }) {
    state.jobList.forEach((job) => {
      if (job) {
        if (job.contact && job.contact.id === newValue.id) {
          const indexJob = getIndexJob(state.jobList, job.protocol);
          const jobStructure = state.jobList[indexJob];
          jobStructure[property] = newValue;
          state.jobList.splice(indexJob, 1, jobStructure);
        }
      }
    });
  },

  [UPDATE_JOB_CONTACT_COLUMNS](state, { newValue, property, contactId }) {
    state.jobList.forEach((job) => {
      if (job) {
        if (job.contact.id === contactId) {
          const indexJob = getIndexJob(state.jobList, job.protocol);
          const jobStructure = state.jobList[indexJob];
          jobStructure[property] = newValue;
          state.jobList.splice(indexJob, 1, jobStructure);
        }
      }
    });
  },

  [SET_CLIENT_TYPING](state, { typing, from }) {
    const indexJob = findIndexJobMessage(from, 'from', state.jobList);
    const job = state.jobList[indexJob];

    job.typing = typing;

    state.jobList.splice(indexJob, 1, job);
  },

  [SET_CLIENT_STATUS](state, { from, newStatus }) {
    const indexJob = findIndexJobMessage(from, 'from', state.jobList);
    const job = state.jobList[indexJob];

    job.clientStatus = newStatus;
    state.jobList.splice(indexJob, 1, job);
  },

  [SET_JOB_TIMES_INFORMATIONS_COMMUNICATOR](state, times) {
    const { whatsapp, voice, chat } = times || {};
    const { activeAttendances } = whatsapp || {};
    const { activeAttendances: activeAttendancesVoice } = voice || {};
    const { activeAttendances: activeAttendanceChat } = chat || {};

    const attendanceTimes = {
      ...activeAttendances,
      ...activeAttendancesVoice,
      ...activeAttendanceChat,
    };

    state.jobList.forEach((job, indexJob) => {
      if (job) {
        job.time = attendanceTimes[job.protocol];
        state.jobList.splice(indexJob, 1, job);
      }
    });
  },

  [NEW_MANUAL_ACTIVATION](state, newJob) {
    state.manualActivations.push(newJob);
  },

  [DELETE_MANUAL_ACTIVATION](state, contactIdentifier) {
    state.manualActivations = state.manualActivations.filter(
      (manualActivation) => manualActivation.whatsapp != contactIdentifier,
    );
  },

  [ADD_MESSAGES_HISTORY_JOB](state, { protocol, messagesHistory }) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];

    if (!job) return;

    job.messages.unshift(...messagesHistory);
  },

  [INCREMENT_PAGE_HISTORY_MESSAGE](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];

    if (!job) return;

    job.paramsHistoryMessages.page++;
  },

  [UPDATE_STATUS_MESSAGE](state, informations) {
    const indexJob = getIndexJob(state.jobList, informations.protocol);
    const job = state.jobList[indexJob];

    if (!job) return;

    console.log('job.messages para atualizar os status ', job.messages);
    let indexMessage = job.messages.findIndex(
      (message) =>
        (message.idPrimary &&
          message.idPrimary == informations.messageUniqueid) ||
        (message.idSecondary &&
          message.idSecondary == informations.messageUniqueid) ||
        (message.id && message.id == informations.messageUniqueid),
    );

    console.log('indice da msg pra atualizar o status', indexMessage);

    let msg = job.messages[indexMessage];
    console.log('msg pra atualizar o status', msg);
    console.log('dados informations', informations);

    if (informations.status) {
      msg.status = informations.status;
      msg.id = informations.messageUniqueid;
      msg.idPrimary = informations.customId
        ? informations.customId
        : informations.messageUniqueid;
      msg.idSecondary = informations.customIdSecondary
        ? informations.customIdSecondary
        : informations.messageUniqueid;
      job.messages.splice(indexMessage, 1, msg);
      state.jobList.splice(indexJob, 1, job);
      // Vue.set(state.joblist, "messages", job.messages)
      // Vue.set(state.messageToSend, informations.protocol, informations.message)
    }
  },

  [UPDATE_MESSAGE_JOB_BY_CUSTOM_ID](
    state,
    { customId, customIdSecondary, idPrimary, idSecondary, protocol, message },
  ) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];
    if (job) {
      console.log('job.messages', job.messages);
      console.log('customId que vou procurar a msg', customId);
      let messageIndexPrimary = job.messages.findIndex(
        (message) =>
          message.custom_id === customId || message.idPrimary === idPrimary,
      );
      let messageIndexSecondary = null;

      console.log('messageIndexPrimary', messageIndexPrimary);

      if (!messageIndexPrimary) {
        console.log(
          'customIdSecondary que vou procurar a msg',
          customIdSecondary,
        );
        messageIndexSecondary = job.messages.findIndex(
          (message) =>
            message.custom_idSecondary === customIdSecondary ||
            message.idSecondary === idSecondary,
        );
        console.log('messageIndexSecondary', messageIndexSecondary);
        job.messages[messageIndexSecondary] = message;
      } else {
        job.messages[messageIndexPrimary] = message;
      }

      state.jobList.splice(indexJob, 1, job);
    }
  },

  [ADD_INBOX_JOB](state, job) {
    state.inboxJobs.push(job);
  },

  [REMOVE_INBOX_JOB](state, protocol) {
    state.inboxJobs = state.inboxJobs.filter((job) => job.protocol != protocol);
  },

  [ADD_INBOX_IN_PROCCESS](state, protocol) {
    state.inbox.inboxInProccess.push(protocol);
  },

  [REMOVE_INBOX_IN_PROCCESS](state, protocol) {
    if (state.inbox.inboxInProccess) {
      state.inbox.inboxInProccess = state.inbox.inboxInProccess.filter(
        (value) => value != protocol,
      );
    }
  },

  [UPDATE_MESSAGE_TO_SEND_BY_JOB](state, informations) {
    // state.messageToSend[informations.protocol] = informations.message
    Vue.set(state.messageToSend, informations.protocol, informations.message);
  },

  [SAVE_UNATTENDED_MESSAGE](state, { message, protocol }) {
    state.unattendedMessages.push({ ...message, protocol });
  },

  [DELETE_UNATTENDED_MESSAGES](state, protocol) {
    state.unattendedMessages = state.unattendedMessages.filter(
      (message) => message.protocol != protocol,
    );
  },

  [ENABLE_CONVERSATION_TAB](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];
    job.startConversation = false;
    state.jobList.splice(indexJob, 1, job);
  },

  [DISABLE_CONVERSATION_TAB](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];

    job.startConversation = true;
    state.jobList.splice(indexJob, 1, job);
  },

  [SET_TRANSFER_ASSISTED](state, isTransfer) {
    state.inTransferAssisted = isTransfer;
  },

  [SET_TRANSFER_ASSISTED_ACCEPTED](state, isTransferAccepted) {
    state.transferAssistedAccepted = isTransferAccepted;
  },

  [DISABLE_CONVERSATION_OPTIONS](state, protocol) {
    state.disableConversationTab = true;
  },

  [ENABLE_CONVERSATION_OPTIONS](state, protocol) {
    state.disableConversationTab = false;
  },
  [ENABLE_JOB_TEMPLATE_CONVERSATION](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];
    job.waitingAnswer = false;
    // Tratamento realizado para quando está aberto o atendimento, e o cliente manda mensagem
    if (job.startConversation) {
      job.startConversation = false;
    }
    state.jobList.splice(indexJob, 1, job);
    console.log('alterando job.waitingAnswer', false);
  },
  [DISABLE_JOB_TEMPLATE_CONVERSATION](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];
    job.waitingAnswer = true;
    state.jobList.splice(indexJob, 1, job);
    console.log('alterando job.waitingAnswer', true);
  },
  [SET_WHATSAPP_KEEP_ALIVE](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);
    let job = state.jobList[indexJob];
    job.keepAlive = true;
    state.jobList.splice(indexJob, 1, job);
  },
  [SET_NEW_WHATSAPP_MESSAGE_NOTIFICATION](state, newNotification) {
    let jobFoundIndex = state.inboxJobs.findIndex(
      (job) =>
        job.routePhone == newNotification.routePhone &&
        job.whatsAppPhone == newNotification.whatsAppPhone,
    );

    if (jobFoundIndex != -1) {
      const inboxJob = state.inboxJobs[jobFoundIndex];
      inboxJob.messages += 1;
      state.inboxJobs.splice(jobFoundIndex, 1, inboxJob);
    }
  },
  [SET_WHATSAPP_TEMPLATE_SENT](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];
    job.templateSent = true;
    state.jobList.splice(indexJob, 1, job);
  },
  [SET_ACK_CALL_REQUEST_DIALOG](state, status) {
    state.ackCallRequest.dialog = status;
  },
  [SET_ACK_CALL_REQUEST_INFORMATION](state, callInformation) {
    state.ackCallRequest.info = callInformation.info;
  },
  [RESET_ACK_CALL_REQUEST_DIALOG](state) {
    state.ackCallRequest.dialog = false;
    state.ackCallRequest.info = {};
  },
  [BACKUP_CURRENT_PROTOCOL_JOBS](state, channel) {
    if (channel == 'whatsapp') {
      const protocolList = state.jobList
        .filter((job) => job.channel.toLowerCase() == 'whatsapp')
        .map((job) => job.protocol);
      state.backupProtocols.push(...protocolList);
    }
  },
  [CLEAN_CURRENT_JOBS](state, channel) {
    const jobsFromOtherChannels = state.jobList.filter(
      (job) => job.channel.toLowerCase() != channel,
    );
    state.jobList.splice(0, state.jobList.length, ...jobsFromOtherChannels);
  },
  [CLEAN_BACKUP_PROTOCOLS](state, protocol) {
    state.backupProtocols = state.backupProtocols.filter(
      (backupProtocol) => backupProtocol != protocol,
    );
  },
  [DISABLED_JOB_ITEMS](state, value) {
    state.disabledJobItems = value;
  },
  [SET_JOB_CHANNEL](state, value) {
    state.channel = value;
  },
  [RESET_AGENT_UNREAD_MESSAGES](state, protocol) {
    const indexJob = getIndexJob(state.jobList, protocol);
    const job = state.jobList[indexJob];
    if (job) {
      job.agentUnreadMessages = 0;
      state.jobList.splice(indexJob, 1, job);
    }
  },
  [SET_LAST_MESSAGE](state, { protocol, message }) {
    Vue.set(state.lastMessages, protocol, message);
  },
  [ADD_ATTENDANCE_JOB](state, job) {
    const indexJob = getIndexJob(state.jobList, job.protocol);
    Vue.set(state.jobList, indexJob, job);
  },
  [ADD_MESSAGE_ANSWERED](state, data) {
    const indexJob = state.jobList.findIndex(
      (job) => job.protocol === data.protocol,
    );

    if (indexJob === -1) return;

    const messages = state.jobList[indexJob].messages;
    const indexMessage = messages.findIndex(
      (message) => message.id === data.messageId,
    );

    if (indexMessage === -1) return;

    const messageAnswered = {
      id: data.messageAnswered.id,
      message: data.messageAnswered.content,
      full_message_answered: data.messageAnswered,
    };

    messages[indexMessage].messageAnswered = messageAnswered;
  },
  [SET_ATTENDANCE_TAGS_JOB](state, { protocol, attendanceTags, merge }) {
    const i = state.jobList.findIndex((job) => job && job.protocol == protocol);
    const job = state.jobList[i];
    if (!job) return;

    const toArray = (v) => (Array.isArray(v) ? v : v ? Object.values(v) : []);

    if (!merge) {
      job.attendanceTags = toArray(attendanceTags);
    } else {
      const current = toArray(job.attendanceTags);
      const incoming = toArray(attendanceTags);

      incoming.forEach((group) => {
        const idx = current.findIndex((g) => g && g.id == group.id);
        const nextItems = toArray(group?.items);
        if (idx === -1) {
          if (nextItems.length > 0) {
            const safeGroup = {
              ...group,
              items: nextItems,
            };
            current.push(safeGroup);
          }
        } else {
          if (nextItems.length === 0) {
            current.splice(idx, 1);
          } else {
            current[idx] = {
              ...current[idx],
              ...group,
              items: nextItems,
            };
          }
        }
      });

      job.attendanceTags = current;
    }

    state.jobList.splice(i, 1, job);
  },

  [SET_CONTACT_TAGS_FOR_CONTACT](state, { contactId, contactTags }) {
    if (!contactId) return;
    const tagsString = Array.isArray(contactTags)
      ? JSON.stringify(contactTags)
      : contactTags || '[]';
    state.jobList.forEach((job, idx) => {
      const jobContact = job && job.contact;
      if (!jobContact) return;
      if (jobContact.id === contactId) {
        const updated = { ...job };
        updated.contact = { ...job.contact, contact_tags: tagsString };
        state.jobList.splice(idx, 1, updated);
      }
    });
  },

  [SET_EMPLOYER_TAGS_FOR_EMPLOYER](state, { employerId, employerTags }) {
    if (!employerId) return;
    const tagsString = Array.isArray(employerTags)
      ? JSON.stringify(employerTags)
      : employerTags || '[]';
    state.jobList.forEach((job, idx) => {
      const jobContact = job && job.contact;
      if (!jobContact) return;
      const jobEmployerId =
        jobContact.employerId ||
        jobContact.employer_id ||
        (jobContact.employer && jobContact.employer.employerId);
      if (jobEmployerId === employerId) {
        const updated = { ...job };
        updated.contact = { ...job.contact, employer_tags: tagsString };
        state.jobList.splice(idx, 1, updated);
      }
    });
  },
  [SET_ACK_CALL_REQUEST_IN_PROGRESS](state, status) {
    state.ackCallRequest.inprogress = status;
  },
  [SET_TRANSFER_ASSISTED_WAITING_CONFIRMATION](
    state,
    isTransferWaitingConfirmation,
  ) {
    state.transferAssistedWaitingConfirmation = isTransferWaitingConfirmation;
  },
};

export default mutations;
